<template>
    <div class="product-selector">
        <img v-if="!steps.length" :src="`${path}product-selecor-bg.jpg`" class="object-cover-absolute" width="100" height="100" alt="background image" />
        <div class="wrapper">
            <breadcrumbs />

            <transition name="fade" mode="out-in">
                <ProductSelectorBuilder v-if="steps.length"/>
                <ProductSelectorIntro v-else/>
            </transition>
        </div>
    </div>
</template>
<script>
import buttonMixin from '~/mixins/buttonMixin'
export default {
    mixins: [buttonMixin],
    computed: {
        steps() {
            return this.$store.state.productSelector.steps
        },
        path() {
            return window.__webpack_public_path__
        }
    }
}
</script>
